require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./tooltip"));
	else if(typeof define === 'function' && define.amd)
		define(["./tooltip"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./tooltip")) : factory(root["./tooltip"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__21__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[38],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__21__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

module.exports = require("react-measure");

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(344);


/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Multilinetruncatedtext = _interopRequireDefault(__webpack_require__(345));

exports["default"] = _Multilinetruncatedtext["default"];
exports.Multilinetruncatedtext = _Multilinetruncatedtext["default"];

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = exports.DEFAULT_DELAY_TIME = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactMeasure = _interopRequireDefault(__webpack_require__(32));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _tooltip = _interopRequireDefault(__webpack_require__(21));

var _Multilinetruncatedtext = _interopRequireDefault(__webpack_require__(346));

var _domMeasureHelpers = __webpack_require__(348);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var multilinetruncatedtextClassName = _Multilinetruncatedtext["default"].multilinetruncatedtextClassName.replace(/"/g, '');

var DEFAULT_DELAY_TIME = 50;
exports.DEFAULT_DELAY_TIME = DEFAULT_DELAY_TIME;

var Multilinetruncatedtext = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Multilinetruncatedtext, _Component);

  function Multilinetruncatedtext(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_updateTextState", function (node, textInfo, numLines, width) {
      var lineWidth = width || node.offsetWidth;
      var info = (0, _domMeasureHelpers.populateText)(lineWidth, numLines, textInfo);
      var disableFlag = false;

      if (_this.props.disableTooltip) {
        disableFlag = true;
      } else if (!_this.props.disableTooltip && _this.props.enforceTooltip) {
        disableFlag = false;
      } else {
        disableFlag = info.disableTooltip;
      }

      return {
        truncatedText: info.text,
        disableTooltip: disableFlag
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_resizeHandler", function (contentRect) {
      _this.contentRect = contentRect;
      clearTimeout(_this.timeout);

      var calculateTruncatedTextValues = _this._calculateTruncatedTextValues.bind((0, _assertThisInitialized2["default"])(_this));

      _this.timeout = setTimeout(function () {
        calculateTruncatedTextValues();
      }, DEFAULT_DELAY_TIME);
    });
    _this.node = null;
    _this.timeout = false;

    _this.setNodeRef = function (element) {
      _this.node = element;
    };

    var disableTooltip = _this.props.disableTooltip; // truncatedText is an array of substrings so intialize it to empty [] until componentDidMount and _resizeHandler calculated
    // the contents of the truncatedText array correctly

    _this.state = {
      disableTooltip: disableTooltip,
      truncatedText: []
    };
    return _this;
  }

  var _proto = Multilinetruncatedtext.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this._calculateTruncatedTextValues();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.textInfo = {
      wordLengths: [],
      ellipsisLength: 0,
      style: {
        lineHeight: this.props.style.lineHeight,
        fontInfo: ''
      }
    };
    this.textInfo = (0, _domMeasureHelpers.updateTextInfo)(this.node, this.textInfo, this.props.value, this.props.numLines);

    var updatedState = this._updateTextState(this.node, this.textInfo, this.props.numLines);

    this.setState(updatedState);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        value = _this$props.value,
        dir = _this$props.dir,
        tooltipDelay = _this$props.tooltipDelay,
        tooltipText = _this$props.tooltipText;
    var title = tooltipText || value;
    var text = [];

    var values = this._processMultiTruncatedTextValues();

    for (var i = 0; i < values.length; i++) {
      text.push( /*#__PURE__*/_react["default"].createElement("div", {
        key: i
      }, values[i]));
    }

    return /*#__PURE__*/_react["default"].createElement(_reactMeasure["default"], {
      bounds: true,
      onResize: this._resizeHandler
    }, function (_ref) {
      var measureRef = _ref.measureRef;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: multilinetruncatedtextClassName + " " + className,
        dir: dir,
        ref: measureRef,
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: _this2.setNodeRef
      }, /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
        disabled: _this2.state.disableTooltip,
        delay: tooltipDelay,
        orient: "top",
        style: {
          width: '100%'
        },
        title: title
      }, text)));
    });
  }
  /*
   * @description Process and return an array of strings where each string is a substring from original text that has been
   * truncated to fit the allowable space of the this.node in the DOM
   *
   * Example: original string this.props.value = 'Greater than or equal to 220%' with this.props.numLines = 3
   * Base on the avalailable space of this.node 'Greater than or equal to 220%' get split into:
   * this.state.truncatedText = ['Greater than or equal', 'to 220%', ''].
   * this.state.truncatedText get render in the DOM as 3 distinct div:
   * <div>Greater than or equal</div>
   * <div>to 220%</div>
   *
   * @return {string[]} Return truncatedText if truncatedText is an Array of string else calculate the substrings and return []
   */
  ;

  _proto._processMultiTruncatedTextValues = function _processMultiTruncatedTextValues() {
    var truncatedText = this.state.truncatedText;

    if (typeof truncatedText === 'string') {
      // check this.node to only to call _calculateTruncatedTextValues when the node is mounted int the dom
      // check this.contentRect to only call _calculateTruncatedTextValues after the mode had been resize
      // When truncatedText is a string in 2 cases: during constructor and setState with truncatedText as string
      // In the first case (construction phase) this.node and this.contentRect are set in componentDidMount and _resizeHandler ,
      // both of these functions set truncatedText to be an array of substrings which cause the Component to be re-render
      // For the second case setState({ truncatedText: 'ABCD....'}), this function call _calculateTruncatedTextValues to convert
      // the string to multiline array of substrings. In this case return [] so that nothing get render in the DOM until the
      // multiline substrings had been calculated. This is to avoid rendering
      // <div>A</div>
      // <div>B</div>
      // <div>C</div>
      // <div>....
      // which cause the vertical array of characters to be display and flash on the screen
      this._calculateTruncatedTextValues();

      return [];
    }

    return truncatedText;
  }
  /*
   * @description Convert text value to mulitiline truncated array of strings and update the state.truncatedText
   * to contain the truncated array of string values
   */
  ;

  _proto._calculateTruncatedTextValues = function _calculateTruncatedTextValues() {
    // check this.node to only to call _calculateTruncatedTextValues when the node is mounted int the dom
    // check this.contentRect to only call _calculateTruncatedTextValues after the mode had been resize
    if (this.node && this.contentRect) {
      var updatedState = this._updateTextState(this.node, this.textInfo, this.props.numLines, this.contentRect.bounds.width);

      var isHeightEqual = (0, _domMeasureHelpers.checkHeight)(this.contentRect.bounds.height, this.textInfo.style.lineHeight);

      if (!isHeightEqual) {
        this.textInfo = (0, _domMeasureHelpers.updateTextInfo)(this.node, this.textInfo, this.props.value, this.props.numLines);
        updatedState = this._updateTextState(this.node, this.textInfo, this.props.numLines);
      }

      this.setState(updatedState);
    }
  };

  return Multilinetruncatedtext;
}(_react.Component);

exports["default"] = Multilinetruncatedtext;
(0, _defineProperty2["default"])(Multilinetruncatedtext, "propTypes", {
  /** Class names to pass in */
  className: _propTypes["default"].string,

  /** Disables the tooltip */
  disableTooltip: _propTypes["default"].bool,

  /** Number of lines to truncate at */
  numLines: _propTypes["default"].number,

  /** Styles to pass in */
  style: _propTypes["default"].object,

  /** Direction of the text */
  dir: _propTypes["default"].oneOf(['', 'auto', 'rtl', 'ltr']),

  /** Delay before the tooltip appears */
  tooltipDelay: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),

  /** text displayed in the tooltip */
  tooltipText: _propTypes["default"].string,

  /** Text to truncate */
  value: _propTypes["default"].string.isRequired,

  /** Enforce the display of tooltip even the text is not long enough (disableTooltip must be set to false) */
  enforceTooltip: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(Multilinetruncatedtext, "defaultProps", {
  className: '',
  disableTooltip: false,
  numLines: 1,
  style: {},
  dir: '',
  tooltipText: '',
  value: '',
  enforceTooltip: false
});

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(347);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-multilinetruncatedtext{display:inline-block;vertical-align:top}\n", ""]);

// exports
exports.locals = {
	"multilinetruncatedtextClassName": "\"ba-multilinetruncatedtext\""
};

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.checkHeight = exports.hasOverflowed = exports.populateText = exports.removeFirstNElements = exports.populateLine = exports.wordCanFit = exports.populateCharacters = exports.updateTextInfo = exports.getTextInfo = exports.getTextWidth = void 0;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
// eslint-disable-next-line no-underscore-dangle
var _cachedCanvas = document.createElement('canvas');

var getTextWidth = function getTextWidth(textToCal, font, isCharacter) {
  var text = textToCal;
  if (!isCharacter) text += ' ';

  var context = _cachedCanvas.getContext('2d');

  context.font = font;
  var metrics = context.measureText(text);
  return metrics.width;
};

exports.getTextWidth = getTextWidth;

var getTextInfo = function getTextInfo(node, value, numLines) {
  var words = value.replace(/\s+/g, ' ').trim().split(' ');
  var lengths = [];
  var maxPossibleLength = Math.floor(numLines) * window.innerWidth;
  var cssData = window.getComputedStyle(node, null);
  var fontData = {
    fontSize: cssData.getPropertyValue('font-size'),
    fontFamily: cssData.getPropertyValue('font-family'),
    fontWeight: cssData.getPropertyValue('font-weight')
  };
  var cumulativeLength = 0;

  for (var i = 0; i < words.length; i++) {
    // We want to avoid getting the width of excessively many words.
    if (cumulativeLength < maxPossibleLength) {
      var width = getTextWidth(words[i], fontData.fontWeight + " " + fontData.fontSize + " " + fontData.fontFamily);
      lengths.push({
        word: words[i],
        length: width
      });
      cumulativeLength += length;
    } else {
      break;
    }
  }

  var styles = {
    lineHeight: cssData.getPropertyValue('line-height'),
    fontInfo: fontData.fontWeight + " " + fontData.fontSize + " " + fontData.fontFamily
  };
  var info = {
    lengths: lengths,
    styles: styles
  };
  return info;
};

exports.getTextInfo = getTextInfo;

var updateTextInfo = function updateTextInfo(node, textInfo, value, numLines) {
  var word = getTextInfo(node, value, numLines);
  textInfo.wordLengths = word.lengths;
  textInfo.ellipsisLength = getTextWidth('...', word.styles.fontInfo, true);
  textInfo.style = word.styles;
  return textInfo;
};

exports.updateTextInfo = updateTextInfo;

var populateCharacters = function populateCharacters(width, word, textInfo) {
  var currentWidth = 0;
  var text = ' ';
  var i = 0;

  while (i < word.length) {
    // Can make this faster by storing character-width associations somewhere (only 26 letters in the alphabet and 10 digits), but too lazy...
    var letterWidth = getTextWidth(word.charAt(i), textInfo.style.fontInfo, true);

    if (currentWidth + letterWidth < width) {
      text += word.charAt(i);
      currentWidth += letterWidth;
      i++;
    } else {
      break;
    }
  }

  return text;
};

exports.populateCharacters = populateCharacters;

var wordCanFit = function wordCanFit(i, numWords, currentWidth, wordWidth, isLast, ellipsisLength, lineWidth) {
  return i < numWords && (currentWidth + wordWidth <= lineWidth - (!isLast || i === numWords - 1 ? 0 : ellipsisLength) || !currentWidth && wordWidth > lineWidth);
};

exports.wordCanFit = wordCanFit;

var populateLine = function populateLine(lineWidth, textInfo, isLast) {
  var wordLengths = textInfo.wordLengths,
      ellipsisLength = textInfo.ellipsisLength;
  var text = '';
  var currentWidth = 0;
  var i = 0;
  var singleWordOverflow = wordLengths[i] ? wordLengths[i].length > lineWidth : false;

  if (!singleWordOverflow) {
    while (i < wordLengths.length && (currentWidth + wordLengths[i].length < lineWidth - (!isLast || i === wordLengths.length - 1 ? 0 : ellipsisLength) || !currentWidth && wordLengths[i].length > lineWidth)) {
      text = text + " " + wordLengths[i].word;
      currentWidth += wordLengths[i].length;
      i++;
    }
  }

  if (i < wordLengths.length && isLast || singleWordOverflow) {
    text += populateCharacters(lineWidth - ellipsisLength - currentWidth, wordLengths[i].word, textInfo);
    if (!isLast && singleWordOverflow) i++;
  }

  var info = {
    text: text,
    index: i,
    singleWordOverflow: singleWordOverflow
  };
  return info;
};

exports.populateLine = populateLine;

var removeFirstNElements = function removeFirstNElements(obj, n) {
  for (var i = 0; i < n; i++) {
    obj.wordLengths.shift();
  }

  return obj;
};

exports.removeFirstNElements = removeFirstNElements;

var populateText = function populateText(lineWidth, numLines, textInfo) {
  var text = [];
  var textObj = textInfo;
  var containsLineWithTrunc = false;

  for (var i = 0; i < numLines; i++) {
    var lineInfo = populateLine(lineWidth, textObj, i === numLines - 1);
    text.push(i === numLines - 1 ? lineInfo.text.trim() : lineInfo.text.trim() + " ");

    if (lineInfo.singleWordOverflow && i !== numLines - 1) {
      text[i] = text[i].trim() + "...";
      if (!containsLineWithTrunc) containsLineWithTrunc = true;
    }

    textObj = removeFirstNElements(textObj, lineInfo.index);
  }

  var isfinishedDisplaying = textObj.wordLengths.length !== 0;

  if (isfinishedDisplaying) {
    text[numLines - 1] = text[numLines - 1].trim() + "...";
  }

  var info = {
    text: text,
    disableTooltip: !isfinishedDisplaying && !containsLineWithTrunc
  };
  return info;
};

exports.populateText = populateText;

var hasOverflowed = function hasOverflowed(height, numLines, lineHeight) {
  return height !== numLines * lineHeight;
};

exports.hasOverflowed = hasOverflowed;

var checkHeight = function checkHeight(height, numLines, lineHeight) {
  if (lineHeight) {
    var lineHeightValue = lineHeight.substr(0, lineHeight.length - 2);
    var parsedLineHeight = parseInt(lineHeightValue, 10);
    return hasOverflowed(height, numLines, parsedLineHeight);
  }

  return false;
};

exports.checkHeight = checkHeight;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[343,0]]]);
});